export default {
  label: "搜索跳转",
  type: "searchJump",
  property: "",
  value: "",
  // options: {
  //   placeholder: "请输入",
  // },
};
